<template>
    <div id="app">
        <!-- 导航栏 -->
        <div class="sys-nav-ctn">
            <div class="flex">
                <div class="sys-title font-lg">车回佳客服管理系统</div>
                <div>
                    <el-menu
                        :default-active="activeIndex"
                        class="nav"
                        background-color="#005aab"
                        text-color="#fff"
                        active-text-color="#fff"
                        mode="horizontal"
                    >
                        <el-menu-item v-for="(item,index) in menu" :index="String(index+1)">
                            <router-link :to="item.Url">{{item.Name}}</router-link>
                        </el-menu-item>
                    </el-menu>
                </div>
            </div>
            <div class="flex">
                <el-dropdown trigger="click" class="loginCenter" @command="stateHandle">
                    <span class="el-dropdown-link">
                        {{userMsg.Name}}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" v-if="!isNoAnyRoot">
                        <el-dropdown-item command="1">
                            <i class="el-icon-circle-check green" v-show="socketStatus == 2"></i>在线
                        </el-dropdown-item>
                        <el-dropdown-item command="0">
                            <i
                                class="el-icon-circle-check gray"
                                v-show="socketStatus == 0 || socketStatus == 5"
                            ></i>下线
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <keep-alive>
            <router-view/>
        </keep-alive>
    </div>
</template>
<script>
export default {
  name: "app",
  components: {},
  data() {
    return {
        isNoAnyRoot:false,
        userMsg: {},
        menu:[]
    };
  },
  computed: {
    activeIndex() {
      return this.$store.state.navLv1; // 切换tab
    },
    // socket 状态
    socketStatus() {
      return this.$store.state.connectState;
    }
  },
  watch: {},
  mounted() {
    // this.beforeClose()
      this.checkRoot()
      this.getLoginUser();
  },
  methods: {
    // 状态处理
    stateHandle(command) {
      if (command == 1) {
        if (this.socketStatus == 2) {
          return;
        }
        this.$store.commit("updateConnectState", 1);
      } else if (command == 0) {
        this.$util.closeSocket();
        this.$store.commit("updateCustomerMsg", {});
      }
    },
    // 获取当前登录客服的信息
    getLoginUser() {
      let token = this.$util.getUrlParam("Token")
        ? this.$util.getUrlParam("Token")
        : this.$util.default_token;
      if (token) {
        localStorage.setItem("token", token);
        document.cookie = "Token=" + token;
      } else {
        token = localStorage.getItem("token");
      }
      if (!token) {
        this.$util.warningMsg('请先登录')
        setTimeout(() => {
          // window.location.href='http://eip.chehuijia.com.cn/Login/Index'
        }, 2000);
        return;
      }
      this.getUserName(token)
      this.getPermission(token)
    },
      // 判断根路由指向
      checkRoot(){
         let tree = this.$util.getSessionStorage('root')
          if(tree){
              this.$util.getNode('客服系统',1).then((res)=>{
                  let menu = res
                  this.menu = menu
                  let haveWorkbench = true
                  let businessUrl = ''
                  for(let i = 0;i <menu.length;i++){
                      if(menu[i].Name == '工作台'){
                          haveWorkbench = true
                      }
                      if(menu[i].Name == '业务管理'){
                          businessUrl = menu[i].Url
                      }
                  }
                  if (!haveWorkbench){
                      this.$router.push(businessUrl)
                  }
              })
          }
      },
      // 获取菜单权限
      getPermission(token){
          this.axios.get("/Common/GetModulesTree", {
              params: {
                  token: token
              }
          })
              .then(res => {
                  let _root = null
                  if(res.data.data[0]){
                      _root = res.data.data[0]
                  }
                  else {
                      this.isNoAnyRoot = true
                      this.$router.push('/noPermission')
                      return
                  }
                  this.$util.setSessionStorage('root',_root)
                  this.checkRoot()
              })
              .catch(error => {
                  console.log(error);
              });
      },
      // 获取顶部用户信息
      getUserName(token){
          this.axios.get("/Common/GetCurrentUser", {
              params: {
                  token: token
              }
          })
              .then(response => {
                  if (response.data.errcode == 0) {
                      let data = response.data.data;
                      this.userMsg = data;
                      this.$util.setSessionStorage("userMsg", data);
                  } else if (response.data.errcode == 500) {
                      this.$util.warningMsg('请先登录')
                      setTimeout(() => {
                          window.location.href = "http://eip.chehuijia.com.cn/Login/Index";
                      }, 2000);
                  }
              })
              .catch(error => {
                  console.log(error);
              });
      },
    // 用户刷新和关闭前提示
    beforeClose() {
      window.onbeforeunload = function(e) {
        e = e || window.event;
        if (e) {
          e.returnValue = "关闭提示";
        }
        return "关闭提示";
      };
    }
  }
};
</script>
<style scoped lang="less">
.green {
  color: greenyellow;
}
.gray {
  color: gainsboro;
}
</style>
<style lang="less">
@import "assets/css/common";
#app {
  height: inherit;
  background: white;
  min-width: 1100px;
}
.sys-nav-ctn {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid @border1Color;
  line-height: 60px;
  background: #005aab;
  color: white;
}

.sys-title {
  outline: 0px;
  padding-left: 20px;
}

.el-menu.el-menu--horizontal {
  border-bottom: none;
}

.identity-ctn {
  display: flex;
  align-items: center;
  .el-form-item {
    margin-bottom: 0;
  }
}
.loginCenter {
  margin: 0 20px;
  color: white;
  cursor: pointer;
}
.el-dropdown-menu__item {
  text-align: right;
}
</style>
